/* globals google */
'use strict';
var MarkerClusterer = require('./markerclusterer');
const MARKER_ICON = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjYiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAyNiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI0LjU5OCAxMi41NDlDMjQuNTk4IDE1LjMyMjQgMjIuOTQ0IDE4LjQ2NiAyMC43MjQ2IDIxLjUyNDRDMTguOTQ0OCAyMy45NzcgMTYuODU1NCAyNi4zMDU0IDE1LjA5MDUgMjguMjcyMUMxNC42NjYgMjguNzQ1MSAxNC4yNjAzIDI5LjE5NzIgMTMuODgyMiAyOS42MjUxQzEzLjE5ODMgMzAuMzk5IDExLjg5OTggMzAuMzk5IDExLjIxNTkgMjkuNjI1MUMxMC44Mzc4IDI5LjE5NzIgMTAuNDMyMSAyOC43NDUxIDEwLjAwNzYgMjguMjcyMUM4LjI0MjY0IDI2LjMwNTQgNi4xNTMyMiAyMy45NzcgNC4zNzM0NSAyMS41MjQ0QzIuMTU0MDMgMTguNDY2IDAuNSAxNS4zMjI0IDAuNSAxMi41NDlDMC41IDUuODk0NTMgNS44OTQ1MyAwLjUgMTIuNTQ5IDAuNUMxOS4yMDM1IDAuNSAyNC41OTggNS44OTQ1MyAyNC41OTggMTIuNTQ5WiIgZmlsbD0id2hpdGUiIHN0cm9rZT0iYmxhY2siLz4KPGNpcmNsZSBjeD0iMTIuNTQ4NCIgY3k9IjEyLjU0OTQiIHI9IjQuMzkyMTYiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo='
const MARKER_ICON_ACTIVE = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNjIiIHZpZXdCb3g9IjAgMCA0OCA2MiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTQ4IDI0QzQ4IDM2LjEzMDYgMzIuNTM3MyA1MS4wMyAyNS42NjkgNTkuMTMwNkMyNC44MDY3IDYwLjE0NzYgMjMuMTkzMyA2MC4xNDc2IDIyLjMzMSA1OS4xMzA2QzE1LjQ2MjcgNTEuMDMgMCAzNi4xMzA2IDAgMjRDMCAxMC43NDUyIDEwLjc0NTIgMCAyNCAwQzM3LjI1NDggMCA0OCAxMC43NDUyIDQ4IDI0WiIgZmlsbD0iYmxhY2siLz4KPGNpcmNsZSBjeD0iMjMuOTk5NiIgY3k9IjIzLjk5OTYiIHI9IjguNCIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==';
const CONTROL_ICON_ZOOMIN = 'url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDQiIGhlaWdodD0iNDQiIHZpZXdCb3g9IjAgMCA0NCA0NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMC43NSIgeT0iMC43NSIgd2lkdGg9IjQyLjUiIGhlaWdodD0iNDIuNSIgcng9IjIxLjI1IiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBkPSJNMjYuNjY3MyAyMi42NjYzSDIyLjY2NzNWMjYuNjY2M0gyMS4zMzRWMjIuNjY2M0gxNy4zMzRWMjEuMzMzSDIxLjMzNFYxNy4zMzNIMjIuNjY3M1YyMS4zMzNIMjYuNjY3M1YyMi42NjYzWiIgZmlsbD0iYmxhY2siLz4KPHJlY3QgeD0iMC43NSIgeT0iMC43NSIgd2lkdGg9IjQyLjUiIGhlaWdodD0iNDIuNSIgcng9IjIxLjI1IiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjEuNSIvPgo8L3N2Zz4K")';
const CONTROL_ICON_ZOOMIN_HOVER = 'url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0NCIgaGVpZ2h0PSI0NCIgdmlld0JveD0iMCAwIDQ0IDQ0IiBmaWxsPSJub25lIj4KPHJlY3QgeD0iMC43NSIgeT0iMC43NSIgd2lkdGg9IjQyLjUiIGhlaWdodD0iNDIuNSIgcng9IjIxLjI1IiBmaWxsPSIjMDAwIi8+CjxwYXRoIGQ9Ik0yNi42NjczIDIyLjY2NzNIMjIuNjY3M1YyNi42NjczSDIxLjMzNFYyMi42NjczSDE3LjMzNFYyMS4zMzRIMjEuMzM0VjE3LjMzNEgyMi42NjczVjIxLjMzNEgyNi42NjczVjIyLjY2NzNaIiBmaWxsPSIjZmZmIi8+CjxyZWN0IHg9IjAuNzUiIHk9IjAuNzUiIHdpZHRoPSI0Mi41IiBoZWlnaHQ9IjQyLjUiIHJ4PSIyMS4yNSIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4KPC9zdmc+")';
const CONTROL_ICON_ZOOMOUT = 'url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDQiIGhlaWdodD0iNDQiIHZpZXdCb3g9IjAgMCA0NCA0NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMC43NSIgeT0iMC43NSIgd2lkdGg9IjQyLjUiIGhlaWdodD0iNDIuNSIgcng9IjIxLjI1IiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBkPSJNMjYuNjY3MyAyMi42NjYzSDE3LjMzNFYyMS4zMzNIMjYuNjY3M1YyMi42NjYzWiIgZmlsbD0iYmxhY2siLz4KPHJlY3QgeD0iMC43NSIgeT0iMC43NSIgd2lkdGg9IjQyLjUiIGhlaWdodD0iNDIuNSIgcng9IjIxLjI1IiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjEuNSIvPgo8L3N2Zz4K")';
const CONTROL_ICON_ZOOMOUT_HOVER ='url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDQiIGhlaWdodD0iNDQiIHZpZXdCb3g9IjAgMCA0NCA0NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMC43NSIgeT0iMC43NSIgd2lkdGg9IjQyLjUiIGhlaWdodD0iNDIuNSIgcng9IjIxLjI1IiBmaWxsPSIjMDAwIi8+CjxwYXRoIGQ9Ik0yNi42NjczIDIyLjY2NzNIMTcuMzM0VjIxLjMzNEgyNi42NjczVjIyLjY2NzNaIiBmaWxsPSIjZmZmIi8+CjxyZWN0IHg9IjAuNzUiIHk9IjAuNzUiIHdpZHRoPSI0Mi41IiBoZWlnaHQ9IjQyLjUiIHJ4PSIyMS4yNSIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4KPC9zdmc+Cg==")';
const CONTROL_ICON_GEOLOCALIZATION = 'url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDQiIGhlaWdodD0iNDQiIHZpZXdCb3g9IjAgMCA0NCA0NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMC43NSIgeT0iMC43NSIgd2lkdGg9IjQyLjUiIGhlaWdodD0iNDIuNSIgcng9IjIxLjI1IiBmaWxsPSJ3aGl0ZSIvPgo8ZyBjbGlwLXBhdGg9InVybCgjY2xpcDBfNTE4NF85NDEwOSkiPgo8cGF0aCBkPSJNMjEuOTk5MyAxOS4zMzM3QzIwLjUyNiAxOS4zMzM3IDE5LjMzMjcgMjAuNTI3IDE5LjMzMjcgMjIuMDAwM0MxOS4zMzI3IDIzLjQ3MzcgMjAuNTI2IDI0LjY2NyAyMS45OTkzIDI0LjY2N0MyMy40NzI3IDI0LjY2NyAyNC42NjYgMjMuNDczNyAyNC42NjYgMjIuMDAwM0MyNC42NjYgMjAuNTI3IDIzLjQ3MjcgMTkuMzMzNyAyMS45OTkzIDE5LjMzMzdaTTI3Ljk1OTMgMjEuMzMzN0MyNy42NTI3IDE4LjU1MzcgMjUuNDQ2IDE2LjM0NyAyMi42NjYgMTYuMDQwM1YxNC42NjdIMjEuMzMyN1YxNi4wNDAzQzE4LjU1MjcgMTYuMzQ3IDE2LjM0NiAxOC41NTM3IDE2LjAzOTMgMjEuMzMzN0gxNC42NjZWMjIuNjY3SDE2LjAzOTNDMTYuMzQ2IDI1LjQ0NyAxOC41NTI3IDI3LjY1MzcgMjEuMzMyNyAyNy45NjAzVjI5LjMzMzdIMjIuNjY2VjI3Ljk2MDNDMjUuNDQ2IDI3LjY1MzcgMjcuNjUyNyAyNS40NDcgMjcuOTU5MyAyMi42NjdIMjkuMzMyN1YyMS4zMzM3SDI3Ljk1OTNaTTIxLjk5OTMgMjYuNjY3QzE5LjQxOTMgMjYuNjY3IDE3LjMzMjcgMjQuNTgwMyAxNy4zMzI3IDIyLjAwMDNDMTcuMzMyNyAxOS40MjAzIDE5LjQxOTMgMTcuMzMzNyAyMS45OTkzIDE3LjMzMzdDMjQuNTc5MyAxNy4zMzM3IDI2LjY2NiAxOS40MjAzIDI2LjY2NiAyMi4wMDAzQzI2LjY2NiAyNC41ODAzIDI0LjU3OTMgMjYuNjY3IDIxLjk5OTMgMjYuNjY3WiIgZmlsbD0iYmxhY2siLz4KPC9nPgo8cmVjdCB4PSIwLjc1IiB5PSIwLjc1IiB3aWR0aD0iNDIuNSIgaGVpZ2h0PSI0Mi41IiByeD0iMjEuMjUiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMS41Ii8+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzUxODRfOTQxMDkiPgo8cmVjdCB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIGZpbGw9IndoaXRlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNCAxNCkiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K")';
const CONTROL_ICON_GEOLOCALIZATION_HOVER = 'url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0NCIgaGVpZ2h0PSI0NCIgdmlld0JveD0iMCAwIDQ0IDQ0IiBmaWxsPSJub25lIj4KPHJlY3QgeD0iMC43NSIgeT0iMC43NSIgd2lkdGg9IjQyLjUiIGhlaWdodD0iNDIuNSIgcng9IjIxLjI1IiBmaWxsPSIjMDAwIi8+CjxnIGNsaXAtcGF0aD0idXJsKCNjbGlwMF81NzM2XzE1MDczKSI+CjxwYXRoIGQ9Ik0yMS45OTkzIDE5LjMzMjdDMjAuNTI2IDE5LjMzMjcgMTkuMzMyNyAyMC41MjYgMTkuMzMyNyAyMS45OTkzQzE5LjMzMjcgMjMuNDcyNyAyMC41MjYgMjQuNjY2IDIxLjk5OTMgMjQuNjY2QzIzLjQ3MjcgMjQuNjY2IDI0LjY2NiAyMy40NzI3IDI0LjY2NiAyMS45OTkzQzI0LjY2NiAyMC41MjYgMjMuNDcyNyAxOS4zMzI3IDIxLjk5OTMgMTkuMzMyN1pNMjcuOTU5MyAyMS4zMzI3QzI3LjY1MjcgMTguNTUyNyAyNS40NDYgMTYuMzQ2IDIyLjY2NiAxNi4wMzkzVjE0LjY2NkgyMS4zMzI3VjE2LjAzOTNDMTguNTUyNyAxNi4zNDYgMTYuMzQ2IDE4LjU1MjcgMTYuMDM5MyAyMS4zMzI3SDE0LjY2NlYyMi42NjZIMTYuMDM5M0MxNi4zNDYgMjUuNDQ2IDE4LjU1MjcgMjcuNjUyNyAyMS4zMzI3IDI3Ljk1OTNWMjkuMzMyN0gyMi42NjZWMjcuOTU5M0MyNS40NDYgMjcuNjUyNyAyNy42NTI3IDI1LjQ0NiAyNy45NTkzIDIyLjY2NkgyOS4zMzI3VjIxLjMzMjdIMjcuOTU5M1pNMjEuOTk5MyAyNi42NjZDMTkuNDE5MyAyNi42NjYgMTcuMzMyNyAyNC41NzkzIDE3LjMzMjcgMjEuOTk5M0MxNy4zMzI3IDE5LjQxOTMgMTkuNDE5MyAxNy4zMzI3IDIxLjk5OTMgMTcuMzMyN0MyNC41NzkzIDE3LjMzMjcgMjYuNjY2IDE5LjQxOTMgMjYuNjY2IDIxLjk5OTNDMjYuNjY2IDI0LjU3OTMgMjQuNTc5MyAyNi42NjYgMjEuOTk5MyAyNi42NjZaIiBmaWxsPSIjZmZmIi8+CjwvZz4KPHJlY3QgeD0iMC43NSIgeT0iMC43NSIgd2lkdGg9IjQyLjUiIGhlaWdodD0iNDIuNSIgcng9IjIxLjI1IiBzdHJva2U9IiMwMDAiIHN0cm9rZS13aWR0aD0iMS41Ii8+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzU3MzZfMTUwNzMiPgo8cmVjdCB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIGZpbGw9IndoaXRlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNCAxNCkiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4=")';

/**
 * appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
function appendToUrl(url, params) {
    var newUrl = url;
    newUrl += (newUrl.indexOf('?') !== -1 ? '&' : '?') + Object.keys(params).map(function (key) {
        return key + '=' + encodeURIComponent(params[key]);
    }).join('&');

    return newUrl;
}

/**
 * Uses google maps api to render a map
 */
function maps() {
    var map;
    var infowindow = new google.maps.InfoWindow();

    // Init U.S. Map in the center of the viewport
    var latlng = new google.maps.LatLng(46.8182, 8.2275);
    var mapOptions = {
        scrollwheel: false,
        zoom: 4,
        center: latlng,
        mapTypeId: 'roadmap',
        mapTypeControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        /* Disabling default UI widgets */
        disableDefaultUI: true

    };

    var styledMapType = new google.maps.StyledMapType(
        [
            {
              "featureType": "administrative",
              "elementType": "geometry",
              "stylers": [
                {
                  "visibility": "off"
                }
              ]
            },
            {
              "featureType": "landscape",
              "elementType": "labels.icon",
              "stylers": [
                {
                  "visibility": "off"
                }
              ]
            },
            {
              "featureType": "landscape.natural.terrain",
              "stylers": [
                {
                  "visibility": "off"
                }
              ]
            },
            {
              "featureType": "poi",
              "stylers": [
                {
                  "visibility": "off"
                }
              ]
            },
            {
              "featureType": "road",
              "elementType": "labels.icon",
              "stylers": [
                {
                  "visibility": "off"
                }
              ]
            },
            {
              "featureType": "transit",
              "stylers": [
                {
                  "visibility": "off"
                }
              ]
            }
          ],
        { name: 'Styled Map' }
    );

    map = new google.maps.Map($('.map-canvas')[0], mapOptions);
    //Associate the styled map with the MapTypeId and set it to display.
    map.mapTypes.set('styled_map', styledMapType);
    map.setMapTypeId('styled_map');
    var mapdiv = $('.map-canvas').attr('data-locations');
    mapdiv = JSON.parse(mapdiv);
    var bounds = new google.maps.LatLngBounds();

    var lat = $('.map-canvas').attr('data-searchkey-lat');
    var long = $('.map-canvas').attr('data-searchkey-long');
    const ZOOM_MARKER_ONCLICK = parseInt($('.map-canvas').attr('data-zoom-marker-onclick') || 12);

    // Customized google map marker icon with svg format
    var markerImg ={
        url: MARKER_ICON,
        scale: 1.8,
        anchor: new google.maps.Point(13, 32),
        labelOrigin: new google.maps.Point(12, 12)
    }
    var markerImgActive = {
        url: MARKER_ICON_ACTIVE,
        scale: 1.8,
        anchor: new google.maps.Point(24, 62),
        labelOrigin: new google.maps.Point(12, 12)
    }

    // This is needed to set the zoom after fitbounds,
    google.maps.event.addListener(map, 'zoom_changed', function () {
        var zoomChangeBoundsListener = google.maps.event.addListener(map, 'bounds_changed', function (event) {
            if (this.getZoom() > 14 && this.initialZoom === true) {
                // Change max/min zoom here
                this.setZoom(14);
                this.initialZoom = false;
            }
            google.maps.event.removeListener(zoomChangeBoundsListener);
        });
    });

    //marker user position
    if (lat && long) {
        var storeLocation = new google.maps.LatLng(lat, long);
        var marker = new google.maps.Marker({
            position: storeLocation,
            map: map,
            title: 'current position',
            zIndex: 100
        });
        bounds.extend(marker.position);
    }
    var selectedMarker = "";
    var markers = {};
    Object.keys(mapdiv).forEach(function (key) {
        var item = mapdiv[key];
        var storeLocation = new google.maps.LatLng(item.latitude, item.longitude);
        var marker = new google.maps.Marker({
            position: storeLocation,
            map: map,
            title: item.name,
            icon: item.selected ? markerImgActive : markerImg,
            zIndex: 105
        });
        if(item.selected) {
            selectedMarker = marker;
        }
        markers[item.id] = marker;
        marker.addListener('click', function () {
            if(selectedMarker != "") {
                selectedMarker.setIcon(MARKER_ICON);
            }
            $('.storesList [type=radio][id^=input-]').prop('checked', false).closest('.card-body').removeClass('active');
            $('.storesList [type=radio]#input-' + item.id).prop('checked', true).closest('.card-body').addClass('active');
            //$('.select-store').prop('disabled', false).trigger('click');
            var selectedStore = $(':checked', '.results-card .results');

            // MOVE SLIDER DEALER TO CORRECT DEALER
            var selectedStoreSlideIndex = selectedStore.closest('.store-group').data('slide-index');
            var slider = document.querySelector('.swiper').swiper;
            if(slider && selectedStoreSlideIndex >= 0) {
                slider.slideTo(selectedStoreSlideIndex);
            }
            $("input[name='storeId']").val(item.id);
            marker.setIcon(MARKER_ICON_ACTIVE);
            selectedMarker = marker;
            map.setZoom(ZOOM_MARKER_ONCLICK);
            map.panTo(marker.getPosition());
        });

        // Create a minimum bound based on a set of storeLocations
        bounds.extend(marker.position);
    });
    // Fit the all the store marks in the center of a minimum bounds when any store has been found.
    if (mapdiv && mapdiv.length !== 0) {
        map.fitBounds(bounds);
        var listener = google.maps.event.addListener(map, "idle", function() {
            if (map.getZoom() > 12)
                map.setZoom(12);
            // var $storeSelected = $("input[name='storeId']").val();
            // if ($storeSelected) {
            //     $('label[for=input-' + $storeSelected + ']').trigger('click');
            //     new google.maps.event.trigger(markers[$storeSelected], 'click');
            // }
            google.maps.event.removeListener(listener);
        });
    }

    MarkerClusterer.default(map, Object.values(markers));
    // Create the DIV to hold the control and call the ZoomControl() constructor
    // passing in this DIV.
    var zoomControlDiv = document.createElement('div');
    var zoomControl = new ZoomControl(zoomControlDiv, map);
    zoomControlDiv.index = 1;
    map.controls[google.maps.ControlPosition.BOTTOM_RIGHT].push(zoomControlDiv);

    $('body').on('click', 'label[for*=input-]', function(e){
        e.preventDefault();
        $(this).find('input').trigger('change');
        $('.storesList [type=radio][id^=input-]').prop('checked', false).closest('.card-body').removeClass('active');
        $(this).find('input').prop('checked', true).closest('.card-body').addClass('active');
        var id = $(this).closest('.card-body').attr('id');
        var markerRelated = markers[id];
        new google.maps.event.trigger(markerRelated, 'click');
    });
}

/**
 * The ZoomControl adds +/- button for the map
 *
 */
 function ZoomControl(controlDiv, map) {

    // Creating divs & styles for custom zoom control
    controlDiv.style.padding = '5px';
    controlDiv.classList.add('right-0');
    
    // Set CSS for the control wrapper
    var controlWrapper = document.createElement('div');
    controlWrapper.style.backgroundColor = 'transparent';
    controlWrapper.style.cursor = 'pointer';
    controlWrapper.style.textAlign = 'center';
    controlWrapper.style.width = '44px'; 
    controlWrapper.style.height = '150px';
    controlWrapper.style.marginBottom = '14px';
    controlWrapper.style.marginRight = '14px';
    controlDiv.appendChild(controlWrapper);

    // Set CSS for the geolocalization
    var geolocalizationButton = document.createElement('div');
    geolocalizationButton.style.width = '44px'; 
    geolocalizationButton.style.height = '44px';
    geolocalizationButton.style.backgroundImage = CONTROL_ICON_GEOLOCALIZATION;
    controlWrapper.appendChild(geolocalizationButton);
  
    // Set CSS for the zoomIn
    var zoomInButton = document.createElement('div');
    zoomInButton.style.width = '44px'; 
    zoomInButton.style.height = '44px';
    zoomInButton.style.marginTop = '8px';
    zoomInButton.style.backgroundImage = CONTROL_ICON_ZOOMIN;
    controlWrapper.appendChild(zoomInButton);
  
    // Set CSS for the zoomOut
    var zoomOutButton = document.createElement('div');
    zoomOutButton.style.width = '44px'; 
    zoomOutButton.style.height = '44px';
    zoomOutButton.style.marginTop = '8px';
    zoomOutButton.style.backgroundImage = CONTROL_ICON_ZOOMOUT;
    controlWrapper.appendChild(zoomOutButton);

    // Setup the click event listener - zoomIn
    $(geolocalizationButton).on({
      "click": () => geolocalizationInit(),
      "mouseover": () => geolocalizationButton.style.backgroundImage = CONTROL_ICON_GEOLOCALIZATION_HOVER,
      "mouseout": () => geolocalizationButton.style.backgroundImage = CONTROL_ICON_GEOLOCALIZATION
    });

    $(zoomOutButton).on({
        "click": () => map.setZoom(map.getZoom() - 1),
        "mouseover": () => zoomOutButton.style.backgroundImage = CONTROL_ICON_ZOOMOUT_HOVER,
        "mouseout": () => zoomOutButton.style.backgroundImage = CONTROL_ICON_ZOOMOUT
    });

    $(zoomInButton).on({
      "click": () => map.setZoom(map.getZoom() + 1),
      "mouseover": () => zoomInButton.style.backgroundImage = CONTROL_ICON_ZOOMIN_HOVER,
      "mouseout": () => zoomInButton.style.backgroundImage = CONTROL_ICON_ZOOMIN
    });
  }

/**
 * Renders the results of the search and updates the map
 * @param {Object} data - Response from the server
 */
function updateStoresResults(data) {
    var $resultsDiv = $('.results');
    var $mapDiv = $('.map-canvas');
    var hasResults = data.stores.length > 0;

    if (!hasResults) {
        $('.store-locator-no-results').show();
    } else {
        $('.store-locator-no-results').hide();
    }

    $resultsDiv.empty()
        .data('has-results', hasResults)
        .data('radius', data.radius)
        .data('search-key', data.searchKey);

    $mapDiv.attr('data-locations', data.locations);
    $mapDiv.attr('data-searchkey-lat', data.searchKey ? data.searchKey.lat || '' : '');
    $mapDiv.attr('data-searchkey-long', data.searchKey ? data.searchKey.long || '' : '');
    if (data.storesResultsHtml) {
      $resultsDiv.append(data.storesResultsHtml);
    }
    if ($mapDiv.data('has-google-api')) {
        maps();
    } else {
        $('.store-locator-no-apiKey').show();
    }
}

/**
 * Search for stores with new zip code
 * @param {HTMLElement} element - the target html element
 * @returns {boolean} false to prevent default event
 */
function search(element, params) {
    var dialog = element.closest('.in-store-inventory-dialog');
    var spinner = dialog.length ? dialog.spinner() : $.spinner();
    spinner.start();
    var $form = element.closest('.store-locator');
    var radius = $('.results').data('radius');
    var url = $form.attr('action');
    var urlParams = { radius: radius };
    if (params) {
        Object.assign(urlParams, params);
    }

    var payload = $form.is('form') ? $form.serialize() : {
            postalCode: $form.find('[name="postalCode"]').val(),
            address: $form.find('[name="storeSearchInput"]').val(),
            storeSelectedId: $('.selectedStore [name=storeId]').val()
    };

    url = appendToUrl(url, urlParams);

    $.ajax({
        url: url,
        type: $form.attr('method'),
        data: payload,
        dataType: 'json',
        success: function (data) {
            spinner.stop();
            updateStoresResults(data);
            $('.select-store').prop('disabled', true);
            $form.find('[name="postalCode"]').val('');
        }
    });
    return false;
}

/**
 * Init stores maps
 */
function init() {
    if ($('.map-canvas').data('has-google-api')) {
        maps();
    } else {
        $('.store-locator-no-apiKey').show();
    }

    if (!$('.results').data('has-results')) {
        $('.store-locator-no-results').show();
    }
}

function geolocalizationInit() {
    $.spinner().start();
        if (!navigator.geolocation) {
            $.spinner().stop();
            return;
        }

        navigator.geolocation.getCurrentPosition(function (position) {
            var $detectLocationButton = $('.detect-location');
            var url = $detectLocationButton.data('action');
            var radius = $('.results').data('radius');
            var urlParams = {
                radius: radius,
                lat: position.coords.latitude,
                long: position.coords.longitude,
                storeSelectedId: $('.selectedStore [name=storeId]').val()
            };

            url = appendToUrl(url, urlParams);
            $.ajax({
                url: url,
                type: 'get',
                dataType: 'json',
                success: function (data) {
                    $.spinner().stop();
                    updateStoresResults(data);
                    $('.select-store').prop('disabled', true);
                }
            });
        },
        function (error) {
            $.spinner().stop();
            let errorMsg = $('#geolocation-error').text();
            toastr.error(errorMsg);
            return;
        });
}

function initAutoComplete(inputAddress, autoCompleteObject) {
    if (!autoCompleteObject && inputAddress) {
        autoCompleteObject = new google.maps.places.Autocomplete(
            inputAddress,
            {
                componentRestrictions: { 'country': ['CH'] }
            }
        );

        //autoCompleteObject.setOptions({ key: $(inputAddress).data('searchApi') });

        autoCompleteObject.addListener('place_changed', () => {
            var place = autoCompleteObject.getPlace();
            if (!place.geometry) {
                return;
            } else {
                search($('.btn-storelocator-search[type="button"]'), { lat: place.geometry.location.lat(), long: place.geometry.location.lng() });
            }
        });
    }
}

function geocodeAndSearch(input) {
    const query = $(input).val();
    if (!query.length) {
        search($(input), {});
        return;
    } else {
        if (query.length < 3) {
            return null;
        }
    }

    const geocoder = new google.maps.Geocoder();
    geocoder.geocode({
        'address': query,
        'componentRestrictions': {
            'country': 'CH'
        }
    }, (res, status) => {
        if (res.length && status === 'OK') {
            const coords = {
                lat: res[0].geometry.location.lat(),
                long: res[0].geometry.location.lng()
            };
            $('.map-canvas').attr('data-searchkey-lat', coords.lat.toString());
            $('.map-canvas').attr('data-searchkey-long', coords.long.toString());
            search($(input), coords);
        } else {
            console.warn('Geocoding error: ', status);
        }
    });
}

module.exports = {
    init: function () {
        var googleMapsApi = $('[name="googleMapsApi"]').val();
        googleMapsApi ? $.getScript(googleMapsApi, init) : init();
    },

    detectLocation: function () {
        // clicking on detect location.
        $('.detect-location').on('click', function () {
            geolocalizationInit()
        });
    },

    search: function () {
        $('.store-locator input#store-text-input').on('keydown', function(e) {
              if (e.key == 'Enter') {
                $('.store-locator-container .btn-storelocator-search[type="button"]').trigger('click');
              }
        });

        $('.store-locator-container .btn-storelocator-search[type="button"]').click(function (e) {
            e.preventDefault();
            geocodeAndSearch($('input#store-text-input'));
            $('.list-group-address-result').html('');
        });
    },

    changeRadius: function () {
        $('.store-locator-container .radius').change(function () {
            var radius = $(this).val();
            var searchKeys = $('.results').data('search-key');
            var url = $(this).data('action-url');
            var urlParams = {};

            if (searchKeys.postalCode) {
                urlParams = {
                    radius: radius,
                    postalCode: searchKeys.postalCode
                };
            } else if (searchKeys.lat && searchKeys.long) {
                urlParams = {
                    radius: radius,
                    lat: searchKeys.lat,
                    long: searchKeys.long
                };
            }

            url = appendToUrl(url, urlParams);
            var dialog = $(this).closest('.in-store-inventory-dialog');
            var spinner = dialog.length ? dialog.spinner() : $.spinner();
            spinner.start();
            $.ajax({
                url: url,
                type: 'get',
                dataType: 'json',
                success: function (data) {
                    spinner.stop();
                    updateStoresResults(data);
                    $('.select-store').prop('disabled', true);
                }
            });
        });
    },

    selectStore: function () {
        $('.store-locator-container').on('click', '.select-store', (function (e) {
            e.preventDefault();

            var selectedStore = $(':checked', '.results-card .results');

            // MOVE SLIDER DEALER TO CORRECT DEALER
            var selectedStoreSlideIndex = selectedStore.closest('.store-group').data('slide-index');
            var slider = document.querySelector('.swiper').swiper;
            if(slider && selectedStoreSlideIndex >= 0) {
                slider.slideTo(selectedStoreSlideIndex);
            }
            
            var data = {
                storeID: selectedStore.val(),
                searchRadius: $('#radius').val(),
                searchPostalCode: $('.results').data('search-key').postalCode,
                storeDetailsHtml: selectedStore.siblings('label').find('.store-details').html(),
                event: e
            };

            $('body').trigger('store:selected', data);
        }));
    },

    updateSelectStoreButton: function () {
        $('body').on('change', '.select-store-input', (function () {
            $('.select-store').prop('disabled', false);
        }));

        var storeId = $("input[name='storeId']").val();
        if (storeId) {
            var $inputStoreInList = $("#input-" + storeId);
            if ($inputStoreInList.length) {
                $inputStoreInList.trigger('change');
            }
        }
    },

    initAutoComplete: function() {
        initAutoComplete($('.store-address-suggestions')[0]);
    }
};